import React, { Component } from "react";
import {Link} from "react-router-dom";


class Service2 extends Component {
  render() {
    return (
        <div>
            {/* ===============  breadcrumb area start =============== */}
            <div className="breadcrumb-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="breadcrumb-wrap">
                                <h2>Machineries Erection &amp; Commissioning</h2>
                                <ul className="breadcrumb-links">
                                    <li>
                                        <Link to={`${process.env.PUBLIC_URL}/`}>Home</Link>
                                        <i className="bx bx-chevron-right" />
                                    </li>
                                    <li>Machineries Erection &amp; Commissioning</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ===============  breadcrumb area end =============== */}
            {/* ===============  faq wrapper start =============== */}
            <div className="faq-wrapper pt-40">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="faq-wrap">
                            <div className="p-timeline-overview">
                              <br/>  <h5>Machineries Erection &amp; Commissioning</h5><br/>
                                <p>Erection is the process of collecting all the machinery parts and  equipment needed for the construction of the plant as per the engineering design recommends.</p><br/>
<p>The erection includes the process from paving ways, constructing main structure, setting equipment and machinery and align it properly.</p><br/>
<p>We do Erection & Commissioning activities in three stages
</p>

<p>&bull; Pre-erection activities to be completed before starting of erection of the any Machinery.</p>
<p>&bull; Assembly of built-in parts of the Machinery.</p>
<p>&bull; Erection of main operating parts of the machinery.</p>
<p>&bull; Commissioning of Final Machinery & Test Run.</p><br/>

<p style={{color:'red'}}>Pre erection activities:</p>

<p>&bull; Preparation of a plan for the implementation of erection work and sequence of various activities</p>
<p>&bull; Arrangement of lighting of erection site and nearby area.</p>
<p>&bull; Ensure the timely supply of equipment and materials needed for continuation of erection work in conjunction with charts and schedules.</p>
<p>&bull; Providing installation plans for hoisting, carrying systems, instruments and equipment as well as coordinating the transfer of material to the site. The content will be removed and transferred to a pre-identified position in the unloading port.</p>
<p>&bull; Arrangement of protective measures to protect workers and machinery during the storage, transport and deployment of various plant components.</p><br/>


<p style={{color:'red'}}>Assembly & Erection of Main Parts of Machinery :</p>
<p>&bull; Assembly of Machinery Parts with proper guidance and zero tolerance safety.</p>
<p>&bull; Erection of Machinery parts handle with competent crew.</p>
<p>&bull; Inspection of assembled parts prior to commissioning.</p><br/>

<p style={{color:'red'}}>Commissioning and Test Run :</p>
<p>&bull; Commissioning of Machinery and Setting up the initial values to the machinery by Hi-Techie personnel. </p>
<p>&bull; Obtaining the required final result and objective of the machinery as expected</p>
<p>&bull; Final Handover with proper training to the operator.</p>

                            </div><br/><br/>



                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* ===============  faq wrapper end =============== */}
        </div>
    );
  }
}

export default Service2;
